import { __extends } from "tslib";
import { Calendar } from 'react-date-range';
import * as moment from 'moment';
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { getFormattedDateString } from '@wix/answers-lib';
export var DatePickerKey = 'date-picker';
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (date) {
            var dateString = getFormattedDateString(date);
            _this.props.onChange(dateString);
        };
        return _this;
    }
    DatePicker.prototype.render = function () {
        var props = this.props;
        var theme = {
            Calendar: { width: 280, color: '#577083', background: '#fcfcfc' },
            PredefinedRanges: { width: 0 },
            MonthAndYear: { fontWeight: 300, fontSize: 16, marginTop: 5, marginBottom: 5 },
            Weekday: { fontWeight: 500, fontSize: 16, marginTop: 5 },
            DaySelected: { background: '#445868' },
            DayInRange: { color: '#fcfcfc', background: '#577083' },
            MonthButton: { background: '#fcfcfc', color: '#445868' },
        };
        var initialDate = function (_) { return moment(props.value); };
        var firstDayOfWeek = props.weekStartsSunday ? 0 : 1;
        return (React.createElement("div", { className: namespacedClassnames(DatePickerKey) },
            React.createElement(Calendar, { firstDayOfWeek: firstDayOfWeek, date: initialDate, onChange: this.onChange, theme: theme, minDate: props.minDate })));
    };
    return DatePicker;
}(React.PureComponent));
export { DatePicker };
//# sourceMappingURL=index.js.map